import './App.css';
import { Routes, Route, BrowserRouter as Router } from 'react-router';
import { Toaster } from 'react-hot-toast';
import { authenticationServices } from 'Services/authenticateServices';
import { lazy } from 'react';
const Factor = lazy(() => import('Components/Admin/Factor'));
const AdminLayout = lazy(() => import('Components/Admin/Layout/AdminLayout'));
const AuthLayout = lazy(() => import('Components/Admin/Auth/'));
function App() {
  const Element = () => {
    return authenticationServices.isAuthenticate() ? <AdminLayout /> : <AuthLayout />;
  };
  return (
    <Router>
      <Routes>
        <Route path="Factor" element={<Factor />} />
        <Route path='*' element={Element()} />
      </Routes>
      <Toaster />
    </Router>

  );
}


export default App;



